var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"todo-node",class:{ 'todo-node--checked': _vm.checked }},[_c('v-checkbox',{staticClass:"todo-node__checkbox",attrs:{"input-value":_vm.checked,"label":_vm.text,"hide-details":""},on:{"change":_vm.onCheckChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }